var map = {
	"./de-DE.json": [
		8429,
		8429
	],
	"./en-US.json": [
		4794,
		4794
	],
	"./fr-CA.json": [
		2519,
		2519
	],
	"./jp-JP.json": [
		7483,
		7483
	],
	"./zh-CN.json": [
		3548,
		3548
	],
	"./zh-TW.json": [
		9032,
		9032
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5272;
module.exports = webpackAsyncContext;